import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { GeneralTasksComponent } from './components/generalTasksComponent';
import { useGeneralTasksStore } from './hooks/useGeneralTasksStore';
import { GeneralTasksTab } from './types/generalTasksTypes';
import { MyGeneralTaskInternal } from './myGeneralTaskInternal';

const TABS = [
  {
    value: GeneralTasksTab.MY_TASKS,
    label: 'My Tasks',
  },
  {
    value: GeneralTasksTab.ALL_TASKS,
    label: 'All Tasks By Assignee',
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    //Same as nportal dashboard
    maxWidth: '1400px',
    flex: 1,
    flexDirection: "column",
    display: "flex"
  },
  layoutBodyContainerClass: {
    flex: 1,
  }
}));

export const GeneralTasks = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { tab } = generalTasksStore;
  const classes = useStyles();

  useEffect(() => {
    generalTasksStore.resetAndFetchOptions();
  }, []);

  const renderTabContent = () => {
    if (tab === GeneralTasksTab.MY_TASKS) {
      return <MyGeneralTaskInternal />;
    }
    return <GeneralTasksComponent />;

  }

  return (
    <Layout title="Tasks" containerClass={classes.container} layoutBodyContainerClass={classes.layoutBodyContainerClass}>
      <Box pb={2}>
        <Tabs
          selectedTab={TABS.findIndex(t => t.value == tab)}
          tabs={Object.values(TABS)}
          onTabChange={(e, i) => generalTasksStore.setTab(TABS[i].value)}
        />
      </Box>
      {renderTabContent()}
    </Layout>
  );
});
